import React from "react";

// Customizable Area Start
import {
  Box,
  styled,
  Typography,
  Divider,
  IconButton,
} from "@material-ui/core";
import TrucatedTextWithTooltip from "../../../components/src/commonComponents/TruncatedTextWithTooltip.web";
import * as assets from "./assets";
import { colors } from "../../../blocks/utilities/src/Colors";
import { Chart } from "react-google-charts";
import DashboardTabPanel from "../../../components/src/DashboardTabPanel.web";
import { FlexiTypo, StyledSpan } from "./CustomerDashboard.web";
import FilterPopover from "../../../components/src/FilterPopover";
import FilterIcon from "@material-ui/icons/FilterListRounded";
import Skeleton from "@material-ui/lab/Skeleton";
import ExportModal from "../../../components/src//ExportModal";
import {
  sortCondition,
  renderBaseOnConditions,
  sortStringCondition,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { getGroupNameDisplay } from "../../cfsalesdashboard3/src/utils";
import InfiniteScroll from "react-infinite-scroll-component";
import { storeNameBasedOnGroup } from "./utils";
import { LoadingComponent } from "../../../components/src/Loader.web";

import AdvanceSalesDashboardController, {
  Props,
  configJSON,
} from "./AdvanceSalesDashboardController.web";

export default class Dashboard extends AdvanceSalesDashboardController {
  constructor(props: Props) {
    super(props);
    // Customizable Area End
  }

  // Customizable Area Start
  renderOverall = () => {
    const {
      advanceSalesData,
      advanceSalesPurchasedData,
      advanceSalesRedeemedData,
      advanceSalesRedementionData,
    } = this.state;

    const discountCreditCards = [

        {
        title: "Total Purchased",
        icon: assets.campaignDiscountIcon,
        orders: advanceSalesPurchasedData?.order_count || 0,
        amount: advanceSalesPurchasedData?.amount || "0.00",
        bgColor: ["#F7F6C0", "#EDECB9"],
      },
      {
        title: "Available Balance",
        icon: assets.generalDiscountIcon,
        // orders: advanceSalesData?.order_count || 0,
        amount: advanceSalesData?.amount || "0.00",
        bgColor: ["#F6F0FF", "#F0E5FF"],
      },
      {
        title: "Total Redeemed",
        icon: assets.loyaltyCreditIcon,
        orders: advanceSalesRedeemedData?.order_count || 0,
        amount: advanceSalesRedeemedData?.amount || "0.00",
        bgColor: ["#DBF9D8", "#CAF4CC"],
      },
      {
        title: "Redemention Rate",
        icon: assets.compensationCreditIcon,
        orders: advanceSalesRedementionData?.order_count || 0,
        amount: advanceSalesRedementionData?.amount || "0.00",
        bgColor: ["#FAE1BF", "#F3D9B5"],
      },
      // {
      //   title: "Redeemed Golden Points",
      //   icon: assets.compensationPaidIcon,
      //   orders: 0,
      //   amount: "0.00",
      //   bgColor: ["#D3E4EA", "#C4DCE5"],
      // },
    ];

    return (
      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "20px",
          padding: "20px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {discountCreditCards.map((card, index) => (
          <FancyBox
            key={card.title}
            style={{
              background: `linear-gradient(135deg, ${card.bgColor[0]}, ${card.bgColor[1]})`,
            }}
          >
            <Box className='top'>
              <Typography className='title'>{card.title}</Typography>
              <img src={card.icon} alt={`${card.title}-icon`} />
            </Box>

            <Box className='bottom'>
              <Box className='stat'>
                <Typography className='statTitle'>
                  {card.title !== "Available Balance" && (
                    <Typography className='statTitle'>
                      {configJSON.ordersTitle}
                    </Typography>
                  )}
                </Typography>
                <Typography className='statValue'>{card.orders}</Typography>
              </Box>
              <Box className='stat'>
                <Typography className='statTitle'>
                  <Typography className='statTitle'>
                    {card.title === "Redemention Rate"
                      ? configJSON.percentage
                      : configJSON.amountTitle}
                  </Typography>
                </Typography>
               <Typography className='statValue'>
                {card.title === "Redemention Rate"
                  ? `${card.amount} %`
                  : `SAR ${card.amount}`}
              </Typography>

              </Box>
            </Box>
          </FancyBox>
        ))}
      </Box>
    );
  };

  renderAllStoreDiscountCard = (
    cardLabel: string,
    cardIcon: string,
    orderQty: string | number,
    orderAmount: string | number
  ) => {
    return (
      <DiscountCard key={`${cardLabel}-store-Card`}>
        <Box className='firstBox'>
          <TrucatedTextWithTooltip
            text={cardLabel}
            charCount={26}
            classNames='discountTitle'
          />
          <img src={cardIcon}></img>
        </Box>
        <Box className='lastBox'>
          <Box className='section'>
            <Typography className='title'>{configJSON.ordersTitle}</Typography>
            <Typography className='value'>{orderQty}</Typography>
          </Box>
          <Box className='section'>
            <Typography className='title'>{configJSON.amountTitle}</Typography>
            <Typography className='value'>SAR {orderAmount}</Typography>
          </Box>
        </Box>
      </DiscountCard>
    );
  };

  renderBullet = (bulletColor: string, label: string) => {
    return (
      <Box className='bulletContainer'>
        <Box className='bulletRage' style={{ background: bulletColor }} />
        <Typography className='label-12-400'>{label}</Typography>
      </Box>
    );
  };

  render() {
    // Customizable Area Start
    return (
      <>
        <Box>
          <DashboardTabPanel
            navigation={this.props.navigation}
            id='AdvanceSalesDashboard'
            permissionStatus={this.state.permissionStatus}
          />
          <SectionWrapper
            id={
              sortCondition(
                this.state.isOpenExportModal,
                "print-wrapper",
                undefined
              ) as string
            }
          >
            <Box>
              <Box id='header' className='headerRowOne'>
                <Box id='hs' className='headerRowOneSubCont'>
                  <FlexiTypo id='t1' Weight={700} FS={"16px"}>
                    Region :{" "}
                    <StyledSpan
                      FS={"16px"}
                      Weight={400}
                      ColorTxt={colors().darkjunglegreen}
                    >
                      {this.state.regionName}
                    </StyledSpan>
                  </FlexiTypo>
                  <FlexiTypo
                    className='ellispseStore'
                    FS={"16px"}
                    Weight={700}
                    id='t2'
                  >
                    Store :{" "}
                    <StyledSpan
                      Weight={400}
                      FS={"16px"}
                      ColorTxt={colors().darkjunglegreen}
                    >
                      {storeNameBasedOnGroup(this.state.storeId)}
                    </StyledSpan>
                  </FlexiTypo>
                  <FlexiTypo
                    className='ellispseStore'
                    FS={"16px"}
                    Weight={700}
                    id='t2'
                  >
                    Group :{" "}
                    <StyledSpan Weight={400} FS={"16px"} ColorTxt='#0F172A'>
                      {getGroupNameDisplay(this.state.groupId)}
                    </StyledSpan>
                  </FlexiTypo>
                </Box>
                <Box className='headerActionCont'>
                  <div
                    id='filterDas'
                    data-test-id='filterButton'
                    onClick={(event) => {
                      this.handleFilterOpen(event);
                    }}
                  >
                    <LoadingComponent
                      disableParentWidth
                      isLoading={this.isLoading()}
                      height={44}
                      width={44}
                      isAllowed={true}
                      children={
                        <IconButton
                          id='btn1'
                          className={sortStringCondition(
                            this.state.isAppliedFilter,
                            "filterBtn active-border",
                            "filterBtn"
                          )}
                        >
                          <FilterIcon color={this.handleReturnColorType()} />
                          {renderBaseOnConditions(
                            this.state.isAppliedFilter,
                            <div className='filterActiveIcon'></div>,
                            <></>
                          )}
                        </IconButton>
                      }
                    />
                  </div>

                  <button
                    className='exportBtn'
                    type='button'
                    onClick={() => this.handleExportModalStats()}
                  >
                    {configJSON.exportAll}
                  </button>

                  <FilterPopover
                    onClose={() => {
                      this.handleCloseFilterPopover();
                    }}
                    anchor={this.state.filterAnchor}
                    data-test-id='filterPopover'
                    filters={this.state.filters}
                    onFilterChange={this.handleFilterChangeAccount}
                  />
                </Box>
              </Box>

              <Box id='h2' className='headerRowTwo'>
                <FlexiTypo Weight={700} FS={"16px"}>
                  Period :{" "}
                  <StyledSpan
                    Weight={400}
                    FS={"16px"}
                    ColorTxt={colors().darkjunglegreen}
                  >
                    {this.handleDateFilterParam().startDateText} _{" "}
                    {this.handleDateFilterParam().endDateText}
                  </StyledSpan>
                </FlexiTypo>
              </Box>
            </Box>

            {this.renderOverall()}
            <Box
              display='flex'
              style={{ gap: "16px", marginTop: "16px" }}
              mt={4}
              flexWrap='wrap'
            >
              <Box
                flex={1}
                minWidth='300px'
                border='1px solid #ECECEC'
                borderRadius='12px'
                p={2}
              >
                <Typography variant='h6' gutterBottom>
                 Packages Sales
                </Typography>
                <Box component='table' width='100%'>
                  <thead>
                    <tr>
                      {[
                        "Stores",
                        "Orders",
                        "Amount",
                        "Base",
                        "Bonus",
                        "Total",
                        "Free Wash Quantity"
                      ].map((heading) => (
                        <th
                          key={heading}
                          style={{
                            textAlign: "left",
                            padding: "8px",
                            borderBottom: "1px solid #ccc",
                            borderRight:
                              heading !== "Total" ? "1px solid #ccc" : "none",
                          }}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.totalSalesData && (
                      <tr>
                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.totalSalesData.total_stores}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.totalSalesData.total_orders}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.totalSalesData.total_price}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.totalSalesData.total_base_points}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.totalSalesData.total_bonus_points}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.totalSalesData.total_points}
                        </td>

                         <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          {this.state.totalSalesData.free_wash_quantity}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Box>
              </Box>

              {/* Second Table */}
              <Box
                flex={1}
                minWidth='300px'
                border='1px solid #ECECEC'
                borderRadius='12px'
                p={2}
              >
                <Typography variant='h6' gutterBottom>
                  Total Redeemed Data
                </Typography>
                <Box component='table' width='100%'>
                  <thead>
                    <tr>
                      {[
                        "Stores",
                        "Orders",
                        "Bonus Point",
                        "Points Used",
                        "Free Wash Pcs",
                        "Value"
                      ].map((heading) => (
                        <th
                          key={heading}
                          style={{
                            textAlign: "left",
                            padding: "8px",
                            borderBottom: "1px solid #ccc",
                            borderRight:
                              heading !== "Total" ? "1px solid #ccc" : "none",
                          }}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.redeemedSummaryData && (
                      <tr>
                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.redeemedSummaryData.total_stores}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.redeemedSummaryData.total_orders}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.redeemedSummaryData.total_bonus_used}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.redeemedSummaryData.total_base_used}
                        </td>

                         <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.redeemedSummaryData.free_wash_pieces}
                        </td>

                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #eee",
                            borderRight: "1px solid #eee",
                          }}
                        >
                          {this.state.redeemedSummaryData.free_wash_amount
                            ? this.state.redeemedSummaryData.free_wash_amount
                            : 0}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Box>
              </Box>
            </Box>

            <Box className='section2'>
              <Box style={{ width: "40%" }} className='containerGraph'>
                <Typography className='label-19-500'>
                  Top Selling Products <span className='label-12-400'></span>
                </Typography>

                <Box className='pieGraphWrapper'>
                  <Box className='pieGraph'>
                    <Chart
                      chartType='PieChart'
                      width='120px'
                      height='200px'
                      data={[
                        ["Product", "Quantity"],
                        ...(this.state.topSellingProductData.length > 0
                          ? this.state.topSellingProductData.map((item) => [
                              item.product_name,
                              item.total_quantity,
                            ])
                          : [
                              ["No Data 1", 1],
                              ["No Data 2", 1],
                              ["No Data 3", 1],
                            ]),
                      ]}
                      options={{
                        ...graphOptions,
                        backgroundColor: "#F8FAFC",
                        legend: "none",
                        pieSliceText: "none",
                        colors:
                          this.state.topSellingProductData.length > 0
                            ? ["#BAADEA", "#AAAD5C", "#F9A825"]
                            : ["#BAADEA", "#AAAD5C", "#F9A825"], // same colors, equal space
                      }}
                    />

                    <Box className='pieHoleTextBig'>
                      <Typography className='label-19-500' align='center'>
                        {this.state.topSellingProductData.length > 0
                          ? this.state.topSellingProductData.length
                          : 0}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box className='bulletWrapper'>
                  {this.state.topSellingProductData.length > 0 ? (
                    this.state.topSellingProductData.map((item, idx) => {
                      const colors = ["#BAADEA", "#AAAD5C", "#F9A825"];
                      return this.renderBullet(
                        colors[idx % colors.length],
                        item.product_name
                      );
                    })
                  ) : (
                    <>
                      {this.renderBullet("#BAADEA", "No Data")}
                      {this.renderBullet("#AAAD5C", "No Data")}
                      {this.renderBullet("#F9A825", "No Data")}
                    </>
                  )}
                </Box>
              </Box>

              <Box style={{ width: "60%" }} className='containerGraph'>
                <Typography className='label-19-500'>
                  Top Redeeming Products <span className='label-12-400'></span>
                </Typography>
                <Box className='pieGraphWrapper'>
                  <Box className='pieGraph'>
                    <Chart
                      chartType='PieChart'
                      width='120px'
                      height='200px'
                      data={[
                        ["Product", "Quantity"],
                        ...(this.state.topRedeemingProductData.length > 0
                          ? this.state.topRedeemingProductData.map((item) => [
                              item.product_name,
                              item.total_quantity,
                            ])
                          : [
                              ["No Data 1", 1],
                              ["No Data 2", 1],
                              ["No Data 3", 1],
                            ]),
                      ]}
                      options={{
                        ...graphOptions,
                        backgroundColor: "#F8FAFC",
                        legend: "none",
                        pieSliceText: "none",
                        colors:
                          this.state.topRedeemingProductData.length > 0
                            ? ["#BAADEA", "#AAAD5C", "#F9A825"]
                            : ["#BAADEA", "#AAAD5C", "#F9A825"],
                      }}
                    />
                    <Box className='pieHoleTextBig'>
                      <Typography className='label-19-500' align='center'>
                        {this.state.topRedeemingProductData.length > 0
                          ? this.state.topRedeemingProductData.length
                          : 0}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box className='bulletWrapper'>
                  {this.state.topRedeemingProductData.length > 0 ? (
                    this.state.topRedeemingProductData.map((item, idx) => {
                      const colors = ["#BAADEA", "#AAAD5C", "#F9A825"];
                      return this.renderBullet(
                        colors[idx % colors.length],
                        item.product_name
                      );
                    })
                  ) : (
                    <>
                      {this.renderBullet("#BAADEA", "No Data")}
                      {this.renderBullet("#AAAD5C", "No Data")}
                      {this.renderBullet("#F9A825", "No Data")}
                    </>
                  )}
                </Box>
              </Box>
            </Box>
            {/* {this.renderAllStore()} */}
          </SectionWrapper>
        </Box>
        {this.state.isOpenExportModal && (
          <ExportModal
            isOpen
            onCancel={this.handleExportModalStats}
            onConfirm={this.handleExportConfirm}
          />
        )}
      </>
    );
    // Customizable Area End
  }
}

const Title = styled(Typography)({
  fontSize: "16px",
  fontWeight: 700,
  fontFamily: "Montserrat",
  lineHeight: "24px",
  color: `${colors().darkjunglegreen}`,
  "& .currencyType": {
    fontWeigth: "400 !important",
  },
});

const SectionWrapper = styled(Box)({
  flexDirection: "column",
  display: "flex",
  gap: 20,
  paddingBottom: 20,
  "& .filterBtn": {
    position: "relative",
    height: "44px",
    width: "44px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    border: "1px solid #ECECEC",
    "& .MuiSvgIcon-root": {
      color: colors().darkliver,
    },
    "&.active-border": {
      borderColor: colors().cyancobaltblue,
    },
    "& .filterActiveIcon": {
      position: "absolute",
      background: "#204B9C",
      top: "-5px",
      right: "-5px",
      minWidth: "15px",
      minHeight: "15px",
      borderRadius: "50%",
    },
  },
  "& .headerActionCont": {
    display: "flex",
    gap: "18px",
  },
  "& .exportBtn": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    background: colors().lightgray,
    fontWeight: 600,
    cursor: "pointer",
    height: "44px",
    border: 0,
    padding: "10px 16px",
    fontSize: "16px",
    color: colors().darkliver,
  },
  "& .ellispseStore": {
    maxWidth: "380px",
    textOverflow: "ellipsis",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  "& .headerRowOne": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
  },
  "& .headerRowOneSubCont": {
    display: "flex",
    gap: "30px",
  },
  "& .headerRowTwo": {},
  "& .pieGraph": {
    position: "relative",
    width: "120px",
    minWidth: "100px",
  },
  "& .pieHoleTextBig": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
  },
  "& .bulletRage": {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
  },
  "& .bulletWrapper": {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  "& .bulletContainer": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  "& .label-19-500": {
    fontSize: "19px",
    fontWeight: 500,
    fontFamily: "Montserrat",
  },
  "& .label-12-400": {
    fontSize: "12px",
    fontWeight: 400,
    fontFamily: "Montserrat",
  },
  "& .containerGraph": {
    padding: "16px",
    borderRadius: "12px",
    border: "1px solid #ECECEC",
    boxSizing: "border-box",
    background: "#F8FAFC",
    minHeight: "247px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  "& .section2": {
    display: "flex",
    gap: "22px",
  },
  "& .overAllContainer": {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    gap: "15px",
    overflowX: "scroll",
    "&.gap-4": {
      gap: 4,
    },
    "&::-webkit-scrollbar": {
      width: "3px",
      height: "3px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "5px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  },
  "&#print-wrapper": {
    "& .headerActionCont": {
      display: "none",
    },
  },
});

const DiscountCard = styled(Box)({
  width: "20%",
  minWidth: "190px",
  backgroundColor: `${colors().brightgray}`,
  borderRadius: "12px",
  "& .firstBox": {
    borderRadius: "12px",
    backgroundColor: `${colors().brightgray}`,
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    padding: "15px 12px 15px 15px",
    alignItems: "center",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    height: "68px",
    width: "100%",
    "& .discountTitle": {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "22.4px",
      color: `${colors().darkjunglegreen}`,
      fontFamily: "Montserrat",
    },
    "& img": {
      height: "24px",
      width: "24px",
    },
  },
  "& .lastBox": {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    padding: "15px 20px 15px 15px",
    gap: "10px",
    "& .section": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "7px",
      "& .title": {
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "22px",
        color: `${colors().darkliver}`,
        fontFamily: "Montserrat",
      },
      "& .value": {
        color: `${colors().darkjunglegreen}`,
        fontSize: "18px",
        fontWeight: 500,
        lineHeight: "22.8px",
        fontFamily: "Montserrat",
      },
    },
  },
});

const FancyBox = styled(Box)({
  width: "22%",
  minWidth: "180px",
  padding: "24px 16px",
  backgroundColor: `${colors().brightgray}`,
  borderRadius: "16px",
  color: "#000", // black text
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  cursor: "pointer",
  boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
  // transform: "skewY(-2deg)",
  transform: "none",

  transition: "transform 0.3s ease, box-shadow 0.3s ease",

  "&:hover": {
    transform: "translateY(-8px) scale(1.05) skewY(-2deg)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
  },
  "& .top": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
    "& .title": {
      fontWeight: 900,
      fontSize: "18px",
      color: "#000",
    },
    "& img": {
      width: "36px",
      height: "36px",
    },
  },
  "& .bottom": {
    display: "flex",
    justifyContent: "space-around",
    "& .stat": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "& .statTitle": {
        fontSize: "14px",
        fontWeight: 600,
        color: "rgba(0,0,0,0.7)",
        marginBottom: "4px",
      },
      "& .statValue": {
        fontSize: "22px",
        fontWeight: 900,
        color: "#000",
      },
    },
  },
});

const AllStoresContainer = styled(Box)({
  border: `1px solid ${colors().lightborder}`,
  borderRadius: "12px",
  display: "flex",
  width: "100%",
  flexDirection: "column",
  marginBottom: "20px",
  padding: "12px 8px",
  "& .boxContainer": {
    display: "flex",
    marginTop: "15px",
    flexDirection: "column",
    gap: "15px",
    "& .hoverBox": {
      padding: "15px 14px",
      borderRadius: "12px",
      backgroundColor: "rgba(233, 237, 245, 0.5)",
      "& .storeTitle": {
        fontSize: "16px",
        marginBottom: "15px",
        fontWeight: 600,
        lineHeight: "19.2px",
        fontFamily: "Montserrat",
      },
    },
  },
  "& .ProgressContainer": {
    margintop: "16px",
    padding: "16px 32px 0",
    display: "flex",
    gap: "115px",
    flexDirection: "row",
    alignItems: "center",
    "& .circularProgress": {
      position: "absolute",

      transform: "rotate(40deg) !important",
    },
    "& .circleLabel": {
      lineHeight: "25px",
      position: "absolute",
      fontFamily: "Montserrat",
      fontSize: "22px",
      color: `${colors().darkjunglegreen}`,
      fontWeight: 500,
    },
  },
});

const graphOptions = {
  pieHole: 0.7,
  legend: "none",
  colors: ["#BAADEA", "#AAAD5C"],
  is3D: false,
  enableInteractivity: true,
  pieSliceText: "none",
  chartArea: { width: "100%", height: "100%" },
};

// Customizable Area End
